import {EventEmitter, Injectable, Output} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {TEXT_PATTERN} from "../../shared/constants/constants";

@Injectable()
export class ModalService {
    modal: any;
    charsLeft:number =100;
    additionalInstructions:string="";
    meetingType:string="";
    showRequiredErrorValidation:boolean=false;
    showInvalidErrorValidation:boolean=false;

    @Output() change: EventEmitter<any> = new EventEmitter();

    constructor(private translate: TranslateService){
        this.modal = null;
    }

    show(title, description, callback) {
        this.modal = {
            title,
            description,
            callback,
            isAdditionalPoint:false
        }
    };

    showAdditionalPickupPointModal(title,description, label, additionalInstructions, meetingType, isAdditionalPoint) {
        this.modal = {
            description,
            title,
            label,
            additionalInstructions,
            isAdditionalPoint,
            tradeName:JSON.parse(localStorage.getItem("company")).tradeName
        }
        this.additionalInstructions=additionalInstructions;
        this.meetingType = meetingType;
        this.showRequiredErrorValidation=false;
        this.showInvalidErrorValidation=false;
    };

    hide(executeCallback) {
        if (executeCallback) {
            this.modal.callback();
        }
        this.modal = null;
    };

    isModalVisible() {
        return this.modal != null && this.modal != undefined;
    };

    isAdditionalPickupPointModal(){
        return !this.modal?false:this.modal.isAdditionalPoint;
    }

    getTitle(){
        return !this.modal?"":this.modal.title;
    }

    getDescription(){
        return !this.modal?"":this.modal.description;
    }

    getLabel() {
        let label= this.translate.instant("modal."+this.modal.label)
                    .replace("{{tradeName}}", this.modal.tradeName)
                    .replace("<b>","")
                    .replace("</b>","");

        return !this.modal ? "" : label;
    }
    getComapanyTradeName(){
        return !this.modal?"":this.modal.tradeName;
    }

    getAdditionalPickupPointLabel(){
        return !this.modal?"":this.modal.label;
    }

    emitAdditionalInstructions() {
        if(this.isValid()){
            this.hide(false)
            const info ={additionalInstructions:this.additionalInstructions,meetingType: this.meetingType};
            this.change.emit(info);
        }
    }

    changed() {
        this.charsLeft = 100 - (this.additionalInstructions?this.additionalInstructions.length:0);
    }

    getCharsLeft(){
        return this.charsLeft;
    }

    getCharsLeftLabel(){
       return this.translate.instant("modal.ADDITIONAL_INSTRUCTIONS.CHARSLEFT").replace("{{charsLeft}}",this.charsLeft);
    }

    isValid() {

        this.showRequiredErrorValidation=false;
        this.showInvalidErrorValidation=false;

        if (!!this.additionalInstructions && this.additionalInstructions.length == 0) {
           this.showRequiredErrorValidation=true;
        }
        else if (!this.validTextField(this.additionalInstructions)) {
            this.showInvalidErrorValidation=true;
        }
        return !this.showRequiredErrorValidation && !this.showInvalidErrorValidation;
    }

    close(){

    }

    validTextField(toValidate) {
        return TEXT_PATTERN.test(toValidate);
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root/modal/modal.service.ts